import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import config from '../../config/config';
import IconLogo from './IconLogo';
import LogoImage from './logo.svg';
import css from './Logo.module.css';

const Logo = ({ className = null, format = 'desktop', ...rest }) => {
  if (format === 'desktop') {
    return (
      <img
        className={className}
        src={LogoImage}
        alt={config.siteTitle}
        {...rest}
      />
    );
  }
  return <IconLogo className={classNames(css.logoMobile, className)} {...rest} />;
};

Logo.propTypes = {
  className: PropTypes.string,
  format: PropTypes.oneOf(['desktop', 'mobile']),
};

export default Logo;
